import { useCallback, useEffect, useState } from 'react';

const SUCCESS_AUTO_DISMISS_MS = 3500;

/** 成功／エラーのフラッシュ文言（成功は数秒で消す） */
export function useRsFlashMessage() {
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');

  const flashSuccess = useCallback((text: string) => {
    setMessage(text);
    setError('');
  }, []);

  const flashError = useCallback((text: string) => {
    setError(text);
    setMessage('');
  }, []);

  const clearFlash = useCallback(() => {
    setMessage('');
    setError('');
  }, []);

  useEffect(() => {
    if (!message || error) return;
    const timer = window.setTimeout(() => setMessage(''), SUCCESS_AUTO_DISMISS_MS);
    return () => window.clearTimeout(timer);
  }, [message, error]);

  return {
    message,
    error,
    flashSuccess,
    flashError,
    clearFlash,
  };
}
